module.exports = __webpack_public_path__ + "static/media/TreySuiter-resume.93b2ba17.pdf";